module.exports = __webpack_public_path__ + "static/img/edge.7306ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/edge.png
// module id = a3ec
// module chunks = 0